import { ISuspendedAccountHasSSRServiceRequestResponse } from '@smiles/core-account/dist/Types/SuspendedAccountHasSSR.types';
import { UpdateMemberServiceRequestType } from '@smiles/core-account/dist/Types/UpdateMember.types';
import { AccountServices, UtilsServices, CoreHelpers, IFinalResponse, Config} from './config';
import { IGeoResponse, IGetZipcodeResponse, IValidateEmailRequest, IValidateEmailResponse } from './types';

export const generateTokenSms = async (phoneNumber: string, recaptcha?: string): Promise<IFinalResponse> => {
  return AccountServices.generateTokenSms({
    phoneNumber,
    recaptcha,
  });
};

export const saveTokenAuthUser = async (token: string): Promise<void> => {
  return Config.saveTokenAuthUser({ accessToken: token });
}

export const validateTokenSms = async (token: string): Promise<IFinalResponse> => {
  return AccountServices.validateTokenSms({ token });
};

export const getMember = async (): Promise<IFinalResponse> => {
  return AccountServices.getMember();
};

export const getMemberInfo = async (): Promise<IFinalResponse> => {
  return AccountServices.getMemberInfo();
};

export const updateMember = async (data: UpdateMemberServiceRequestType): Promise<IFinalResponse> => {
  return AccountServices.updateMember(data);
};

export const generateTokenEmail = async (): Promise<IFinalResponse> => {
  return AccountServices.sendTokenEmail({ tokenType: 'EMAIL_VALIDATION' });
};

export const validateTokenEmail = async (token: string): Promise<IFinalResponse> => {
  return AccountServices.validateTokenEmail({ token, tokenType: 'VERIFICATION_CODE' });
};

export const getListCountry = async (): Promise<IFinalResponse> => {
  return UtilsServices.getListCountry({ brFirst: true });
};

export const getPartnerToken = async (type: string): Promise<IFinalResponse> => {
  return UtilsServices.partnerToken({ partner: type as any });
};

export const getConstants = (...keys: any[]): any => {
  return CoreHelpers.getConstants(...keys);
};

export const suspendedAccountHasSSR = async (): Promise<ISuspendedAccountHasSSRServiceRequestResponse> => {
  return AccountServices.suspendedAccountHasSSR();
};

export const validateEmail = async ({
  email,
  document,
  recaptcha,
}: IValidateEmailRequest): Promise<IValidateEmailResponse> => {
  return AccountServices.validateEmail({ email, document, recaptcha }) as unknown as IValidateEmailResponse;
};

export const getZipCode = async (zipcode: string): Promise<IGetZipcodeResponse> => {
  return UtilsServices.getZipCode({ zipcode }) as unknown as IGetZipcodeResponse;
};

export const getGeocoding = async (value: string): Promise<IGeoResponse> => {
  return UtilsServices.getGeoLocation({
    input: value,
    locationType: 'GEOLOCATION',
  }) as unknown as IGeoResponse;
};
